module.exports = __webpack_public_path__ + "static/media/chevron-left.44cf8cc1.svg";